import { useCallback, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import "./userdesktop.scss"; 
import AQCheckinTable from "../../../../ReuseableComponents/Table/Table";
import { UserTableColumns } from "./UserTable.uitl";
import { getUsersList } from "../../../../../apis/userApis/getUsersList";
import { deleteUser } from "../../../../../apis/userApis/deleteUser";
import AQModal from "../../../../ReuseableComponents/AQModal/Modal/Modal";
import { getUserData } from "../../../../../apis/userApis/getUser";
import { lockUser } from "../../../../../apis/userApis/lockUser";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { unLockUser } from "../../../../../apis/userApis/unLockUser";
import CreateNewUser from "./createNewUser";
import { toast } from "react-toastify";
import Loader from "../../../../ReuseableComponents/Loader/Loader";
import EditModal from "../../../../ReuseableComponents/Modal/Modal";
import UpdateUserES from "../UserManagement/UpdateUserES";
import { UserTableColumnsES } from "./UserTable.uitlES";

type Props = {};

interface UserDataProps {
  id: number;
  type: string;
}

export interface FilterUsers {
  filterUsers: any;
  filterUsersLoading: any;
  usertype: any;
}
const UserDesktopES = ({ filterUsers, filterUsersLoading, usertype }: FilterUsers) => {
  const navigate = useNavigate();
  const { data, error } = useQuery(["getUserList"], getUsersList, {
    refetchInterval: 1000,
  });
  const [userData, setUserData] = useState<UserDataProps>({
    id: 0,
    type: "",
  });

  const [showModal, setshowModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [isLock, setIsLock] = useState();
  const [modalEdit, setModalEdit] = useState(false);
  const [editUserID, setEditUserID] = useState();

  const handleOpenModalEdit = () => {
    setTimeout(() => {
      setModalEdit(true);
    }, 500);
  };

  const handleCloseModalEdit = () => {
    setModalEdit(false);
  };

  useEffect(() => {
    if (userData?.id) {
      getUserData(userData?.id)
        .then((resp) => {
          setIsLock(resp?.is_lock);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [isLock, userData]);

  const toggle = () => {
    setModal(!modal);
  };

  const onDelete = useCallback(
    (id: number) => {
      setUserData({
        id: id,
        type: "delete",
      });
      setshowModal(!showModal);
    },
    [showModal, setshowModal]
  );
  const onEdit = useCallback(
    (id: number) => {
      setUserData({
        id: id,
        type: "edit",
      });
      setshowModal(!showModal);
    },
    [showModal, setshowModal]
  );

  const onLock = useCallback(
    (id: number) => {
      setUserData({
        id: id,
        type: "lock",
      });
      setshowModal(!showModal);
    },
    [showModal, setshowModal]
  );

  const onConfirm = () => {
    if (userData?.type === "delete") {
      deleteUser(userData?.id)
        .then((resp) => {
          setshowModal(false);
          toast.success("Usuario eliminado con éxito");
        })
        .catch((err) => {
          setshowModal(false);
          if (err) toast.error(err?.response?.data?.error);
        });
    } else if (userData?.type === "edit") {
      getUserData(userData?.id)
        .then((resp) => {
          setshowModal(false);
          setEditUserID(resp?.id);
          handleOpenModalEdit();
        })
        .catch((err) => {
          setshowModal(false);
        });
    } else if (userData?.type === "lock") {
      (isLock ? unLockUser(userData?.id) : lockUser(userData?.id))
        .then((resp) => {
          setshowModal(false);
          toast.success("El estado del usuario cambió exitosamente");
        })
        .catch((err) => {
          setshowModal(false);
          if (err) toast.error(err?.response?.data?.error);
        });
    } else return;
  };

  return (
    <div>
      {filterUsersLoading ? <Loader width={300} /> :
       (
          <div className="table">
            <AQCheckinTable
              columns={UserTableColumnsES(onDelete, onEdit, onLock)}
              data={usertype ? filterUsers?.users : data?.users}
            />
          </div>
      )}

      <Modal
        isOpen={showModal}
        toggle={() => setshowModal(!showModal)}
        className="user-modal"
      >
        <AQModal
          nextBtnText={
              <Button className="confirm-btn" onClick={onConfirm}>
                Sí
              </Button>
          }
          cancelBtnText={
              <Button
                className="cancel-btn"
                onClick={() => setshowModal(false)}
              >
                Cancelar
              </Button>
          }
          modal={showModal}
          onConfirm={onConfirm}
          onExitModal={() => setshowModal(!showModal)}
        >
          <span className="user-modal-body">
          Estás seguro que quieres {userData?.type === "edit" && "Editar"}
            {userData?.type === "delete" && "Borrar"}
            {isLock
              ? userData?.type === "lock" && "Desbloquear"
              : userData.type === "lock" && "Cerrar"}
            ?
          </span>
        </AQModal>
      </Modal>
      
      <div className="col-md-3">
        {modalEdit && (
          <EditModal
            title="Actualizar Usuario"
            content={<UpdateUserES handleCloseModalEdit={handleCloseModalEdit} editUserID={editUserID}/>}
            onClose={handleCloseModalEdit}
          />
        )}
      </div>
    </div>
  );
};

export default UserDesktopES;
